import { REGENERATE_DOCUMENTS } from '../../constants/actions/policy';

export function regenerateDocuments(payload) {
    return {
        type: REGENERATE_DOCUMENTS,
        payload,
    };
}
